import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Join.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { JOIN_NODE_DESCRIPTION, NodeTypes } from '../../utils';

export const JoinNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Join' description={JOIN_NODE_DESCRIPTION} nodeType={NodeTypes.JOIN} imgPath={stepIcon} />
}